import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { productListReducer, productDetailsReducer } from './reducers/productReducers';
import { userLoginReducer } from './reducers/userReducers';
import { cartReducer } from './reducers/cartReducers';

const reducer = combineReducers({
	productList: productListReducer,
	productDetails: productDetailsReducer,
	cart: cartReducer,
	userLogin: userLoginReducer,
});

const cartItemsFromStorage = localStorage.getItem('cartItems')
		?JSON.parse(localStorage.getItem('cartItems'))
		: []
	
const userInfoFromStorage = localStorage.getItem('userInfo')
		? JSON.parse(localStorage.getItem('userInfo'))		
		: null;

const initialState = {
	cart:{cartItems:cartItemsFromStorage},
	userLogin:{userInfo: userInfoFromStorage}
}

const middleware = [thunk]
const store = createStore(reducer, initialState, composeWithDevTools(applyMiddleware(...middleware)))


export default store